/** Search existing option labels without changing native variant data. */
class CardOptionSearch extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.input = this.querySelector('input');
    this.results = this.querySelector('[data-results]');
    this.status = this.querySelector('[role="status"]');
    if (!this.input || !this.results || !this.status) return;
    this.hidden = false;
    this.input.addEventListener('input', () => this.search(), { signal });
    this.input.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        this.input.value = '';
        this.search();
      } else if (event.key === 'Enter' || event.key === 'ArrowDown') {
        event.preventDefault();
        this.results.querySelector('button')?.focus();
      }
    }, { signal });
    this.results.addEventListener('keydown', (event) => {
      const buttons = [...this.results.querySelectorAll('button')];
      const index = buttons.indexOf(event.target);
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        buttons[Math.max(0, Math.min(buttons.length - 1, index + (event.key === 'ArrowDown' ? 1 : -1)))]?.focus();
      } else if (event.key === 'Escape') {
        this.input.focus();
      }
    }, { signal });
    this.results.addEventListener('click', (event) => {
      const button = event.target.closest('button[data-value]');
      const select = this.getSelect();
      if (!button || !select) return;
      select.value = button.dataset.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      this.input.value = '';
      this.results.replaceChildren();
      this.results.hidden = true;
      this.status.textContent = this.dataset.selected.replace('[card]', button.textContent);
      this.input.focus();
    }, { signal });
  }
  getSelect() {
    let sibling = this.nextElementSibling;
    while (sibling && sibling.localName !== 'variant-picker') sibling = sibling.nextElementSibling;
    return sibling?.querySelector('select[id="' + CSS.escape(this.dataset.selectId) + '"]');
  }
  disconnectedCallback() { this.controller?.abort(); }
  search() {
    const select = this.getSelect();
    const words = this.input.value.trim().toLocaleLowerCase().split(/\s+/).filter(Boolean);
    this.results.replaceChildren();
    this.results.hidden = words.length === 0;
    this.status.textContent = '';
    if (!words.length || !select) return;
    const matches = [...select.options].filter(option =>
      words.every(word => option.textContent.toLocaleLowerCase().includes(word)));
    const shown = matches.slice(0, 12);
    for (const option of shown) {
      const button = document.createElement('button');
      button.type = 'button';
      button.dataset.value = option.value;
      button.textContent = option.textContent.trim();
      this.results.append(button);
    }
    this.status.textContent = matches.length
      ? this.dataset.matches.replace('[shown]', String(shown.length)).replace('[total]', String(matches.length))
      : this.dataset.empty;
  }
}
if (!customElements.get('card-option-search')) {
  customElements.define('card-option-search', CardOptionSearch);
}
